import { render, staticRenderFns } from "./AssignedStudentRow.vue?vue&type=template&id=72fc3edd&scoped=true"
import script from "./AssignedStudentRow.vue?vue&type=script&lang=js"
export * from "./AssignedStudentRow.vue?vue&type=script&lang=js"
import style0 from "./AssignedStudentRow.vue?vue&type=style&index=0&id=72fc3edd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc3edd",
  null
  
)

export default component.exports